import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";

export const OtpField = ({ value, onChange, testId = "otp-input" }) => (
  <InputOTP maxLength={6} value={value} onChange={onChange} data-testid={testId}>
    <InputOTPGroup>
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <InputOTPSlot key={i} index={i} className="h-12 w-11 text-lg font-mono" />
      ))}
    </InputOTPGroup>
  </InputOTP>
);
